export default {
  SET(state, { type, value }) {
    // eslint-disable-next-line no-param-reassign
    state[type] = value;
  }
};
